<template>
    <div class="main">
        <router-view
            @show="onShow()"
            @hide="onHide()"
        ></router-view>

        <section v-if="show" class="sectionFeaturedWorks">
            <div class="containerWrapper">
                <div class="container">
                    <div class="headlineWrapper">
                        <fade-transition @after-enter="onHeadlineShow" :delay="isMobile ? 500 : 0" appear>
                            <h1 v-show="headlineShow" class="headline headline-h1">
                                {{ title }}
                            </h1>
                        </fade-transition>
                    </div>

                    <div class="content">
                        <fade-transition @after-enter="onReelsShow"
                                         :duration="{enter: 500}" appear>
                            <div v-if="reels && reelsShow" class="featuredVideosLinkListContainer">
                                <ul class="featuredVideosLinkListWrapper">
                                    <li v-for="reel in reels"
                                        :key="reel.name"
                                        class="featuredVideosLinkList"
                                    >
                                        <h2 v-if="isActiveReel(reel)" :class="classes(reel)">{{ reel.name }}</h2>
                                        <a v-else
                                           :href="reel.link"
                                           :class="classes(reel)"
                                           @click.prevent="onReelClick(reel)"
                                        >
                                            {{ reel.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </fade-transition>

                        <media-list
                            :medias="medias"
                            :gridSize="5"
                            :listClass="'featuredVideoListContainer'"
                            :delay="500"
                            v-if="mediasShow">
                        </media-list>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import {menusNames as mn,} from "../constants/menus";
import {menusMixin} from "../mixins/menus";

export default {
    mixins: [menusMixin,],
    data() {
        return {
            headlineShow: false,
            reelsShow: false,
            mediasShow: false,
            show: false,
        }
    },
    computed: {
        ...mapGetters('ui', [
            'isMobile',
        ]),
        ...mapGetters('menus', {
            getMenu: 'get',
        }),
        ...mapGetters('featured', {
            medias: 'medias',
            reels: 'reels',
            reel: 'reel',
        }),
        ...mapState({
            current: state => state.player.current,
        }),
        title() {
            return this.$_getMenuName(mn.FEATURED_WORK)
        }
    },
    created() {
    },
    mounted() {
        if (!this.current) {
            this.onShow()
        }
    },
    methods: {
        onShow() {
            //console.log('home-detail: onShow')

            if (!this.show) {
                this.show = true
                this.headlineShow = true
            }
        },
        onHeadlineShow() {
            this.reelsShow = true
        },
        onReelsShow() {
            this.mediasShow = true
        },
        onHide() {
        },
        classes(reel) {
            return [
                'singleEditorLink',
                {'singleEditorLink-current': this.isActiveReel(reel)}
            ]
        },
        isActiveReel(reel) {
            return this.reel.name === reel.name
        },
        onReelClick(reel) {
            this.$store.commit('featured/setReel', reel)

            if (this.$route.name !== 'featured-detail') {
                this.$router.push({name: 'featured-reel', params: {reel: reel.slug}})
            }
        },
    },
    watch: {},
}
</script>

